// node_modules
import { useState, useEffect } from "react";
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
// Types
import { TUseFetch } from "Types";
// Helpers
import { AxiosHelperSingleton } from "Helpers";

export const useFetch = <T>(url: string, dependencies: any[] = [], options?: AxiosRequestConfig): TUseFetch<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [didError, setDidError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [fetchedData, setFetchedData] = useState<T | null>(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        let isMounted = true;
        
        if (options) { 
            options.cancelToken = source.token;
        } else {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            options = {
                cancelToken: source.token
            };
        }

        async function fetch() {
            try {
                setIsLoading(true);
                const response: AxiosResponse<T> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}${url}`, {cancelToken: source.token});
                if (isMounted) {
                    setFetchedData(response.data);
                    setIsLoading(false);
                    setDidError(false);
                    setErrorMessage("");
                }
            } catch (error) {
                if (isMounted) {
                    let errorMessageToDisplay = "Something went wrong, please contact our support team.";
                    // in the case where there is an error message in the response
                    // we use it instead of using the default error message 
                    if (axios.isAxiosError(error)) {
                        const typedError = (error as AxiosError);
                        if (typedError.response && 
                                typedError.response.data &&
                                typeof typedError.response.data === "string") {
                            errorMessageToDisplay = typedError.response.data;
                        }
                    }
                    setErrorMessage(errorMessageToDisplay);
                    setDidError(true);
                    setIsLoading(false);
                }
            }
          }

          fetch();
          
          return () => {
              isMounted = false;
              source.cancel();
          };
    }, [url, options, ...dependencies]);
  
    return { isLoading, didError, errorMessage, fetchedData };
};